export default __webpack_public_path__ + "static/media/Icon awesome-mobile-alt.13a0f003.svg";